import { Tooltip } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';
import clsx from 'clsx';
import {
  POLICY_DATE_FUTURE_TOOLTIP,
  POLICY_DATE_OLDER_90_TOOLTIP,
  POLICY_DATE_OLDER_THAN_DAYS,
} from 'features/constants';
import moment from 'moment';
import { formatDate } from './reportsListConfig';

type PolicyDateRendererProps = {
  value?: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconSpacing: {
      display: 'flex',
      marginLeft: theme.spacing(1),
    },
    warningIcon: {
      color: theme.palette.warning.main,
    },
  }),
);

const PolicyDateRenderer = ({ value }: PolicyDateRendererProps) => {
  const classes = useStyles();
  const policyDt = moment(value);
  const currDt = moment(new Date());
  const isFutureDate = !!value && +new Date(value) > +new Date();
  const dayDiff = moment.duration(currDt.diff(policyDt)).asDays();

  if (isFutureDate) {
    return (
      <div className="d-flex-center">
        {formatDate(value ?? '')}
        <Tooltip title={POLICY_DATE_FUTURE_TOOLTIP} placement="right" arrow>
          <span className={clsx(classes.iconSpacing, classes.warningIcon)}>
            <ReportProblemOutlined />
          </span>
        </Tooltip>
      </div>
    );
  }

  if (dayDiff > POLICY_DATE_OLDER_THAN_DAYS) {
    return (
      <div className="error-status d-flex-center">
        {formatDate(value ?? '')}
        <Tooltip title={POLICY_DATE_OLDER_90_TOOLTIP} placement="right" arrow>
          <span className={classes.iconSpacing}>
            <ErrorOutlineIcon />
          </span>
        </Tooltip>
      </div>
    );
  }

  return <div>{formatDate(value ?? '')}</div>;
};

export default PolicyDateRenderer;
